import React, {Component} from 'react';
import {connect} from 'react-redux';
import Properties from '../../shared/Properties';
import {fetchContractorProperties} from '../../../actions';

class Container extends Component {
    render() {
        const {match: {params: {contractor}}, fetchProperties} = this.props;
        const fetchProps = (landlord, page) => {
            return fetchProperties(landlord, contractor, page);
        };
        return <Properties {...this.props} includeHeader={false} fetchProperties={fetchProps}/>;
    }
}

const mapStateToProps = (state, ownProps) => {
    const properties = state.landlord.properties.active;

    return {
        landlord: state.me.application.id,
        properties: [...properties.data],
        meta: properties.meta,
        loading: properties.isFetching,
    };
};

export default connect(mapStateToProps, {fetchProperties: fetchContractorProperties})(Container);



// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/contractor/Properties.js